import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { OptimizelyDecideOption } from '@optimizely/react-sdk';
import getClient from '.';
import { getPrefixedKey } from './universal-credit';
export default ( /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId, attributes) {
    var client, decisions;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getClient();
        case 2:
          client = _context.sent;
          decisions = client.decideAll([OptimizelyDecideOption.DISABLE_DECISION_EVENT], userId, attributes);
          Object.keys(decisions).forEach(function (key) {
            var prefixedKey = getPrefixedKey(key);
            var decision = decisions[key];
            if (prefixedKey !== key && decisions[prefixedKey]) {
              decision = decisions[prefixedKey];
            }
            var _decision = decision,
              enabled = _decision.enabled,
              variables = _decision.variables;
            decisions[key] = {
              enabled: enabled,
              variables: variables
            };
          });
          return _context.abrupt("return", decisions);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})());